import { Injectable } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Router } from '@angular/router';
import { ConstantsService } from '../constants/constants.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class IdleService {
  constructor(
    private idle: Idle,
    private router: Router,
    private constants: ConstantsService,
    private toastr: ToastrService
  ) {
    this.initIdleTimeout();
  }

  initIdleTimeout() {
    this.idle.setIdle(1800); // 29 minutes of inactivity
    this.idle.setTimeout(60); // 1-minute warning countdown
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onTimeoutWarning.subscribe((countdown: number) => {
      if (countdown === 60) {
        this.toastr.warning(
          'You will be logged out in 1 minute due to inactivity.',
          'Session Expiring Soon'
        );
      }
    });

    this.idle.onTimeout.subscribe(() => {
      this.toastr.info('You have been logged out due to inactivity.', 'Session Timeout');
      this.stopIdleWatch();
      this.constants.clearSession();
      this.router.navigate(['/login']);
    });

    this.idle.watch();
  }

  stopIdleWatch() {
    this.idle.stop();
  }

  resetIdleWatch() {
    this.idle.stop();
    this.idle.watch();
  }
}
